import React, {Component} from 'react';
import {connect} from "react-redux";
import { Player } from 'video-react';
import {hashHistory} from "react-router";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";

import {setIntroVideo} from "../actions/actionFunctions";

class IntroVideo extends Component {

  player = null;

  handleNextClick = () => {
    if (+this.props.match.params.step === 3) {
      this.props.setIntroVideo({
        introVideoFinished: true
      });
      hashHistory.push("materials");
    } else {
      hashHistory.push("/tutorial-intro/" + (+this.props.match.params.step + 1));
    }
    // this.props.setIntroVideo({
    //   show: this.props.introVideo.step <= 1,
    //   step: ++this.props.introVideo.step
    // });
  };

  componentDidMount() {
    this.props.setIntroVideo({
      introVideoStarted: true
    });
    if (!this.props.match.params.step || this.props.match.params.step > 3) {
      hashHistory.push("/tutorial-intro/1");
    }
    this.player.play();
    setTimeout(() => {
      this.player.play(); // in case first time is not auto launched
    }, 500)
  }

  getStepText = (step) => {
    switch (step) {
      case 1:
        return {
          title: "introVideo.step1.title",
          subTitle: "introVideo.step1.subTitle"
        }
      case 2:
        return {
          title: "introVideo.step2.title",
          subTitle: "introVideo.step2.subTitle"
        }
      case 3:
        return {
          title: "introVideo.step3.title",
          subTitle: "introVideo.step3.subTitle"
        }
      default:
        return {}
    }
  }

  render() {

    const videoPath = "https://intro-videos.s3.amazonaws.com";
    const videos = {
      1: videoPath + "/steps-scene.WebM",
      2: videoPath + "/lock-scene.WebM",
      3: videoPath + "/checkout-scene.WebM"
    }
    const step = +this.props.match.params.step;
    const text = this.getStepText(step);

    return this.props.introVideoFinished ? null : (
      <div className="in-video">
        <div className="in-video-popup">
          <div className={"in-video-popup__text in-video-popup__text--" + this.props.match.params.step}>
            {step === 3 ? <h3 className="in-video-popup__text-subtitle"><FormattedMessage id={text.subTitle}/></h3> : null}
            <h2 className="in-video-popup__text-title"><FormattedMessage id={text.title}/></h2>
            {step !== 3 ? <h3 className="in-video-popup__text-subtitle"><FormattedMessage id={text.subTitle}/></h3> : null}
          </div>
          <Player
            ref={player => { this.player = player; }}
            playsInline
            fluid={this.props.windowWidth < 991}
            autoPlay={true}
            src={videos[step]}
          />
          <button className={this.props.windowWidth < 991
              ? "ui-button2 ui-button2--green in-video-button"
              : "ui-button3 ui-button3--green in-video-button"}
                  onClick={this.handleNextClick}>
            <FormattedMessage id={step === 3 ? "introVideo.buttons.start" : "introVideo.buttons.next"}/>
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {introVideo} = store.serverState;
  return {
    introVideoFinished: introVideo.introVideoFinished,
    windowWidth: store.serverState.windowWidth,
  };
};

const mapDispatchToProps = {
  setIntroVideo
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(IntroVideo)
);
